import script from "./InputTrouble.vue?vue&type=script&setup=true&lang=js"
export * from "./InputTrouble.vue?vue&type=script&setup=true&lang=js"

import "./InputTrouble.vue?vue&type=style&index=0&id=d83dd5fc&lang=css"

const __exports__ = script;

export default __exports__